export default __webpack_public_path__ + "static/media/2001.68fa0e84.jpg";